<template src="./template.html">
</template>

<script>
import StringUtils from 'utils/StringUtils'
import { filter } from 'ramda'

export default {
  props: {
    conditions: {
      type: Array,
      default: () => []
    },
    conditionsFreeText: {
      type: Object,
      default: () => ({
        config: {
          label: 'Tìm kiếm'
        }
      })
    },
    disableFreeText: {
      type: Boolean,
      default: false
    },
    defaultQuery: {
      type: Object,
      default: () => ({
        filter: []
      })
    },
    maxNumAdd: {
      type: Number,
      default: 1
    },
    saveFiler: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      listConditionConfig: {
        label: 'Điều kiện',
        datasource: {
          options: this.conditions.filter(item => item.show === true || this.R.isNil(item.show)).map(item => ({
            label: this.R.path(['config', 'label'], item),
            value: this.R.merge(item.config, { filterBoxOnly: item }),
          })),
          emitValue: true,
          label: 'label',
          value: 'value'
        },
        sortBy: 'label',
        mapOptions: true,
      },
      chipsModel: this.R.zipObj(
        this.conditions.map(item => this.R.path(['config', 'fieldName'], item)),
        this.R.times(() => ({}), this.R.length(this.conditions))
      ),
      conditionModel: null,
      valueModel: {},
      menuModel: false,
      textInput: [],
      query: this.R.clone(this.defaultQuery),
      REGEX: new RegExp('^(<|>)=?$'),
      privateFilter: [],
      numAdd: 0,
      removeIndex: -1,
      inputValue: null
    }
  },
  created() {
    this.recoverFilter()
  },
  mounted() {
    // this.recoverFilter()
    this.search()
  },
  methods: {
    recoverFilter() {
      // registerFilterState
      this._data = this._.merge(this._data, this.R.path([this.$route.fullPath], this.$store.getters.filter))
    },
    saveFilter() {
      let obj = {}
      obj[this.$route.fullPath] = this._data
      this.$store.dispatch('registerFilterState', obj)
    },
    addCondition() {
      this.menuModel = false
      let filterBoxOnly = this.R.path(['filterBoxOnly'], this.conditionModel)
      let condition = this.R.path(['filterBoxOnly', 'query'], this.conditionModel)
      let fieldName = this.R.path(['fieldName'], this.conditionModel)
      let label = this.R.path(['label'], this.conditionModel)
      let options = this.R.path(['datasource', 'options'], this.conditionModel)
      let oldLabelIndex = this.R.findIndex(this.R.startsWith(label), this.textInput)
      this.textInput = oldLabelIndex !== -1 ? this.R.remove(oldLabelIndex, 1, this.textInput) : this.textInput
      // add query filter
      this.query.order = this.isGTOrLT(condition[1])
      condition[2] = this.valueModel[fieldName]
      this.privateFilter = this.R.append(condition, this.privateFilter)
      this.query.filter = this.R.concat(this.privateFilter, this.defaultQuery.filter)
      // Map label to search bar
      let labelAfterMap = filterBoxOnly.mapLabel ? 
      (Array.isArray(filterBoxOnly.mapLabel) ? this.mapLabelDefault(this.valueModel[fieldName], options, filterBoxOnly.mapLabel) : filterBoxOnly.mapLabel(this.valueModel[fieldName], options)) 
      : this.valueModel[fieldName]
      this.textInput.push(`${label}: ${labelAfterMap}`)
      // Store to chip
      this.chipsModel[fieldName] = {
        index: this.textInput.length - 1,
        value: [`${label}: ${labelAfterMap}`],
        query: condition
      }
      this.search()
    },
    mapLabelDefault (value, options, mapLabel) {
      let filter = options.filter(item => item[mapLabel[0]] === value)
      if(filter[0]) {
        return filter[0][mapLabel[1]]
      }
      return ''
    },
    isGTOrLT(currentCondition) {
      for(let item of this.privateFilter) {
        if(this.REGEX.exec(item[1])) {
          return null
        }
      }
      if(this.REGEX.exec(currentCondition)) {
        return null
      }
      return this.defaultQuery.order
      // this.REGEX.exec(condition[1]) ? null : this.defaultQuery.order
    },
    search() {
      this.$emit('query', Object.assign({ textInput: this.textInput }, this.query), this.textInput)
      this.saveFilter()
    },
    searchClick() {
      if(!this.R.isEmpty(this.inputValue) && !this.R.isNil(this.inputValue)) {
        this.textInput.push(this.inputValue)
        this.add({index: this.textInput.length - 1, value: this.inputValue})
        this.input(this.inputValue)
        this.inputValue = null
      }
      this.search()
    },
    input(value) {
      if(this.removeIndex !== -1) {
        this.textInput = this.R.remove(this.removeIndex, 1, this.textInput)
        this.removeIndex = -1
      }
    },
    onInputBlur(e) {
      this.inputValue = e.target.value
    },
    // { index, value }
    add(detail) {
      if(this.numAdd >= this.maxNumAdd || this.disableFreeText) {
        this.removeIndex = detail.index
        this.$refs.searchBar.removeAtIndex(detail.index)
        return
      }
      this.numAdd++
      let nfdData = StringUtils.removeAccents(detail.value)
      if(!this.R.isNil(this.conditionsFreeText) && !this.R.isEmpty(this.conditionsFreeText)) {
        this.chipsModel.freeText = {
          index: detail.index,
          value: [detail.value],
          query: this.conditionsFreeText.query
        }
        this.conditionsFreeText.query[2] = nfdData
        this.privateFilter = this.R.append(this.conditionsFreeText.query, this.privateFilter)
        this.query.filter = this.R.concat(this.privateFilter, this.defaultQuery.filter || [])
        this.search()
      }
    },
    // { index, value }
    removeChip(detail) {
      let [key, val] = Object.entries(this.chipsModel).find(obj => this.R.equals(detail, obj[1]) || this.R.equals(detail.value, obj[1].value))
      this.chipsModel[key] = {}
      this.privateFilter = this.R.reject(this.R.equals(val.query), this.privateFilter)
      if(this.textInput.length === 0) {
        this.privateFilter = []
      }
      this.query.filter = this.R.concat(this.privateFilter, this.defaultQuery.filter || [])
      this.search()
      if(this.R.isEmpty(this.chipsModel.freeText)) {
        this.numAdd = 0
      }
    }
  },
  computed: {
    valueComponent() {
      return this.R.path(['type'], this.conditionModel) || 'Select'
    },
    valueFieldName() {
      return this.R.path(['fieldName'], this.conditionModel) || 'default'
    },
    valueCondition() {
      return this.conditionModel || {
        label: 'Giá trị',
        datasource: {
          options: [],
          label: 'label',
          value: 'value'
        }
      }
    }
  },
}
</script>